import { ControlValueAccessor, NgModel, NgControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { ViewChild, Injector, AfterContentInit, OnDestroy, AfterContentChecked } from '@angular/core';
import { Subscription } from 'rxjs';
import { isEquals } from './util';

export abstract class BaseControlValueAccessor implements ControlValueAccessor, AfterContentInit, AfterContentChecked, OnDestroy {

    @ViewChild(NgModel)
    protected model: NgModel;

    public isInvalid: boolean;

    public isValid: boolean;

    public isRequired: boolean;

    protected _control: NgControl;

    private modelValue: any;

    private sub: Subscription;

    onChange: (_: any) => void;

    onTouched: () => void;

    constructor(private injector: Injector) { }

    writeValue(_value: any): void {

    }

    registerOnChange(fn: any): void {
        this.onChange = (value) => {
            this.modelValue = value;
            this.modelValueChanged(value);
            fn(value);
        };
        if (typeof this.model !== 'undefined') {
            this.model.valueAccessor.registerOnChange(this.onChange);
        }
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
        if (typeof this.model !== 'undefined') {
            this.model.valueAccessor.registerOnTouched(fn);
        }
    }

    setDisabledState?(isDisabled: boolean): void {
        this.model.valueAccessor.setDisabledState(isDisabled);
    }

    ngAfterContentInit(): void {
        this._control = this.injector.get(NgControl); // NOSONAR
        this.sub = this._control.valueChanges.subscribe(value => {
            this.modelValue = value;
            this.modelValueChanged(value);
        });
    }

    ngAfterContentChecked(): void {
        this.isInvalid = this._control.invalid && (this._control.touched || this._control.dirty);
        this.isValid = this._control.valid;
        const validators: Array<Function  | Validator> = this.injector.get(NG_VALIDATORS, null) || [];
        this.isRequired = validators.some(validator => (validator as any).required);
        if (typeof this.model !== 'undefined') {
            if (this._control.touched && !this.model.touched) {
                this.model.control.markAsTouched();
            }
        }
    }

    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    getModelValue(): any {
        return this.modelValue;
    }

    hasValue(): boolean {
        return this.modelValue !== '' && this.modelValue !== undefined && this.modelValue !== null;
    }

    protected abstract modelValueChanged(value: any): void;

    protected isEquals(x, y): boolean {
       return isEquals(x, y);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/core/base-control-value-accessor.ts